<template>
  <v-dialog v-model="dialog" persistent width="900">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ form.id ? "Editar Persona" : "Crear Persona" }} -
          {{
            form.tipo_persona && form.tipo_persona[0] == 1
              ? "Servidor público"
              : "Pasante"
          }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md class="py-0" style="min-width: 100%;">
            <v-layout wrap>
              <v-flex md3>
                <v-autocomplete
                  class="text-field-reducido-border"
                  outline
                  :items="tipo_documentos"
                  item-text="descripcion"
                  :item-value="val => parseInt(val.id)"
                  label="Tipo de documento"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.id_tipo_documento"
                ></v-autocomplete>
              </v-flex>
              <v-flex md3>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  @change="obtenerNrodoc()"
                  label="Número de documento"
                  v-model="form.nro_doc"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                  :disabled="!form.id_tipo_documento > 0"
                ></v-text-field>
              </v-flex>
              <v-flex md2>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  label="Complemento"
                  v-model="form.nro_complemento"
                  maxlength="200"
                ></v-text-field>
              </v-flex>
              <v-flex md2>
                <v-autocomplete
                  class="text-field-reducido-border"
                  outline
                  :items="expedidos"
                  item-text="valor"
                  item-value="valor"
                  label="Expedido en"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.expedido"
                ></v-autocomplete>
              </v-flex>
              <v-flex md2>
                <v-autocomplete
                  class="text-field-reducido-border"
                  outline
                  :items="sexos"
                  item-text="valor"
                  :item-value="val => parseInt(val.id)"
                  label="Sexo"
                  :rules="$validate(['required'])"
                  required
                  v-model="form.id_parametro_sexo"
                ></v-autocomplete>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  class="text-field-reducido-border mayuscula"
                  outline
                  label="Apellido paterno"
                  v-model="form.ap_paterno"
                  maxlength="200"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  class="text-field-reducido-border"
                  outline
                  label="Apellido materno"
                  v-model="form.ap_materno"
                  maxlength="200"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  class="text-field-reducido-border mayuscula"
                  outline
                  label="Apellido casada"
                  v-model="form.ap_casada"
                  maxlength="200"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  class="text-field-reducido-border mayuscula"
                  outline
                  label="Nombres"
                  v-model="form.nombres"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                ></v-text-field>
              </v-flex>
              <v-flex xs12><h3 class="blue--text">Foto</h3></v-flex>
              <v-flex xs12 md6 class="text-xs-center" :key="key_actualizacion">
                <div :class="this.file == '' ? 'file-empty' : 'file-upload'">
                  <v-icon large>{{
                    this.file == "" ? "file_upload" : "done"
                  }}</v-icon>
                  <br />
                  <input
                    class="input-file"
                    type="file"
                    @change="handleFileUpload()"
                    ref="file"
                    accept="image/jpeg, image/png, image/gif"
                  />
                  <p>
                    {{
                      this.file == ""
                        ? "Arrastra y suelta cualquier archivo aquí"
                        : "El archivo se cargo exitosamente!"
                    }}
                  </p>
                  <span>
                    {{
                      this.file == ""
                        ? "o haz click aqui para buscar archivos desde el dispositivo"
                        : "Arrastra y suelta un archivo o haz click aqui para cambiar de archivo"
                    }}
                  </span>
                </div>
              </v-flex>
              <v-flex xs12 md6>
                <v-img
                  v-if="imagen_previsualizada && imagen_previsualizada != ''"
                  :aspect-ratio="16 / 9"
                  contain
                  :src="imagen_previsualizada"
                >
                </v-img>
              </v-flex>
              <v-flex xs12 class="text-xs-center">
                <div
                  class="file-block"
                  v-if="this.file.size || adjunto.size_file"
                >
                  <v-icon>description</v-icon>
                  <div class="file-info">
                    <span>{{ this.file.name || adjunto.nombre_archivo }} </span>
                    |
                    <span>
                      {{
                        size_file_calculate(this.file.size) ||
                          size_file_calculate(adjunto.size_file)
                      }}</span
                    >
                  </div>
                  <v-icon @click="eliminaArchivo()">delete</v-icon>
                </div>
                <p
                  class="red--text body-1 ma-0"
                  v-if="errors.size"
                  :rules="$validate(['required'])"
                >
                  *Archivo demasiado grande(Mayor a 2Mb)
                </p>
                <p
                  class="red--text body-1 ma-0"
                  v-if="errors.denied"
                  :rules="$validate(['required'])"
                >
                  *Formato no admitido por el sistema, solo se acepta imagenes
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <!-- <v-card-text class="grey lighten-2 text--info" v-if="form.id">
          <v-layout wrap>
            <v-flex class="px-3">
              <strong>
                Usuario y correo electrónico
              </strong>
            </v-flex>
          </v-layout>
        </v-card-text> -->
        <!-- <v-card-text v-if="form.id">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md6>
                <v-text-field
                  label="Nombre de usuario"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                  disabled
                  :value="form.usuarios.length > 0 && form.usuarios !== null ? form.usuarios[0].nombre_usuario : 'SIN USUARIO'"
                ></v-text-field>
              </v-flex>
              <v-flex md6>
                <v-text-field
                  label="Correo electrónico"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                  disabled
                  :value="form.usuarios.length > 0 && form.usuarios !== null ? form.usuarios[0].correo : 'SIN CORREO ELECTRONICO'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text> -->
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            :loading="loading"
            :disabled="!valid"
          >
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
      tipo_documentos: [],
      sexos: [],
      expedidos: [],
      encontrado: false,
      // Variables archivo adjunto
      file: "",
      errors: {
        file: true,
        size: false,
        denied: false
      },
      key_actualizacion: 1,
      adjunto: {},
      imagen_previsualizada: "",
      url_backend: process.env.API_URL.split("api/")[0]
    };
  },
  mounted() {
    this.obtenerTipoDocumentos();
    this.obtenerSexos();
    this.obtenerExpedidos();
    this.$bus.$on("openDialogCrearActualizarPersona", item => {
      this.form = item;
      this.dialog = true;
      // Edicion
      if (!!item.id) {
        if (!!this.form.foto) {
          this.file = {
            ruta:this.form.foto,
            size:1
          };
          this.imagen_previsualizada = this.url_backend + this.form.foto;
        }
      }
    });
  },
  methods: {
    // Metodo para devolver tamaño de archivo
    size_file_calculate(size) {
      // if (typeof this.file == "object") {
      if (0 < size && size < 512000) {
        return `${(size / 1024).toFixed(2)}KB`;
      }
      if (512000 <= size) {
        return `${(size / (1024 * 1024)).toFixed(2)}MB`;
      }
    },
    eliminaArchivo() {
      this.file = "";
      this.key_actualizacion++;
      this.errors.file = true;
      this.errors.size = false;
      this.errors.denied = false;
      this.imagen_previsualizada = "";
    },
    // Metodo para cargar file
    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].size > 2048999) {
          this.errors.size = true;
        } else {
          this.errors.size = false;
        }
        if (this.$refs.file.value === "") {
          this.errors.file = true;
        } else {
          this.errors.file = false;
        }
        if (this.$refs.file.files[0].type.includes("image/")) {
          this.errors.denied = false;
        } else {
          this.errors.denied = true;
        }
        this.file = file;
        // Lo convertimos a un objeto de tipo objectURL
        const objectURL = URL.createObjectURL(file);
        this.imagen_previsualizada = objectURL;
      }
    },
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.file = "";
      this.imagen_previsualizada = "";
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async obtenerTipoDocumentos() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							tipoDocumentos{
								rows{
									id
									descripcion
								}
							}
						}
					`
        });
        this.tipo_documentos = res.tipoDocumentos.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerSexos() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							params(tipo: "SEXO"){
								rows{
									id
									valor
								}
							}
						}
					`
        });
        this.sexos = res.params.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerExpedidos() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							params(tipo: "CARNET DE IDENTIDAD"){
								rows{
									id
									valor
								}
							}
						}
					`
        });
        this.expedidos = res.params.rows;
      } catch (error) {
        console.log(error);
      }
    },
    async obtenerNrodoc() {
      try {
        let res = await this.$service.graphql({
          query: `
						query{
							personaFindNroDoc(nro_doc:"${this.form.nro_doc}", id_tipo_documento: ${this.form.id_tipo_documento}){
								id
								ap_paterno
								ap_materno
								ap_casada
								nombres
								id_tipo_documento
								nro_doc
								nro_complemento
								sexo
								expedido
								id_parametro_sexo
							}
						}
					`
        });
        if (res.personaFindNroDoc) {
          this.form = res.personaFindNroDoc;
        }
      } catch (error) {
        console.log(error);
      }
    },

    //guardar persona
    async save() {
      //console.log(this.form)
      if (this.$refs.form.validate()) {
        if (!this.form.ap_paterno && !this.form.ap_materno) {
          return this.$message.error(
            "Falta Apellido Paterno o Apellido Materno"
          );
        }
        this.loading = true;
        let datos_usuario = [];
        // Validamos archivo
        if (!!this.file) {
          // Validamos tamano y tipo del archivo
          if (this.errors.denied) {
            return this.errors;
          }
          if (this.errors.size) {
            return this.errors;
          }
        }
        let ruta_archivo = "";
        // Verificamos si hay ruta de archivo
        if (!!this.form.foto && !!this.file) {
          ruta_archivo = this.form.foto;
        }
        // Subimos el archivo
        if (!!this.file.type) {
          ruta_archivo = await this.$service.uploadFile(this.file);
          // Validamos que se subio un archivo
          if (!ruta_archivo) {
            this.$alert(
              "Ocurrio un error con la subida del archivo, intentelo nuevamente por favor"
            );
            return;
          }
        }
        try {
          if (this.form.id) {
            // const id = this.form.id
            // delete this.form.id
            // delete this.form._user_created
            // delete this.form._user_updated
            // delete this.form._created_at
            // delete this.form._updated_at
            // await this.$service.graphql({
            // 	query: `
            // 		mutation edit($id: ID!, $persona: EditPersona!){
            // 			personaEdit(id: $id, persona: $persona){
            // 				id
            // 			}
            // 		}
            // 	`,
            // 	variables: {
            // 		id: id,
            // 		persona: this.form
            // 	}
            // })
            this.loading = true;
            let user = this.$storage.get("user");
            if (this.form.nro_complemento == null) {
              this.form.nro_complemento = "";
            }
            if (this.form.ap_casada == null) {
              this.form.ap_casada = "";
            }
            try {
              let respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select persona.fn_modif_persona_basico(${
                      this.form.id
                    },${this.form.id_tipo_documento},'${this.form.nro_doc}','${
                  this.form.nro_complemento
                }','${this.form.expedido}','${
                  this.form.id_parametro_sexo
                }','${this.form.ap_paterno.toUpperCase()}','${this.form.ap_materno.toUpperCase()}','${this.form.ap_casada.toUpperCase()}','${this.form.nombres.toUpperCase()}',${
                  user.id
                },${this.form.tipo_persona[0]},'${ruta_archivo}')"){
                      respuesta
                    }
                  }
                `
              });
              if (respuesta.runQuery.respuesta[0].fn_modif_persona_basico) {
                this.$message.success();
                this.loading = false;
                this.close();
              } else {
                this.$message.error();
                this.loading = false;
              }
              // this.$bus.$emit(
              //   "closeDialogCreado",
              //   respuesta.runQuery.respuesta[0].fn_modif_persona_basico
              // );
              this.$bus.$emit("closeDialog");
            } catch (error) {
              console.log(error);
              this.loading = false;
            }
          } else {
            this.loading = true;
            let user = this.$storage.get("user");
            if (this.form.nro_complemento == null) {
              this.form.nro_complemento = "";
            }
            if (this.form.ap_casada == null) {
              this.form.ap_casada = "";
            }
            if (this.form.ap_paterno == null) {
              this.form.ap_paterno = "";
            }
            if (this.form.ap_materno == null) {
              this.form.ap_materno = "";
            }
            try {
              let respuesta = await this.$service.graphql({
                query: `
                  query{
                    runQuery(consulta:"select persona.fn_alta_persona_usuario(${
                      this.form.id_tipo_documento
                    },'${this.form.nro_doc}','${this.form.nro_complemento}','${
                  this.form.expedido
                }','${
                  this.form.id_parametro_sexo
                }','${this.form.ap_paterno.toUpperCase()}','${this.form.ap_materno.toUpperCase()}','${this.form.ap_casada.toUpperCase()}','${this.form.nombres.toUpperCase()}',${
                  user.id
                }, '${this.$moment(new Date()).format("YYYY-MM-DD")}',${
                  this.form.tipo_persona[0]
                },'${ruta_archivo}')"){
 											respuesta
 										}
 									}
									
								`
              });
              let resp =
                respuesta.runQuery.respuesta[0].fn_alta_persona_usuario;
              let resps = resp.split("|");
              let correcto = resps[0];

              this.$message.success(resps);
              //enviar correos
              //OBTENER DATOS DEL JEFE DE LA UTI
              let rpta = await this.$service.graphql({
                query: `
                      query{
                            runQuery(consulta:"select m.id_persona,vp.correo ,vp.nombres,vp.ap_paterno ,vp.ap_materno from movilidad.movilidad m left join persona.v_persona_usuario vp on vp.id_persona =m.id_persona where m.id_item =3491 and m.id_estado in (1,53)limit 1"){
                            respuesta
                            }
                          }	
                      `
              });
              datos_usuario = rpta.runQuery.respuesta[0];

              let correo_funcionario = resp.split("-");
              if (datos_usuario) {
                console.log("notif correo:", datos_usuario);
                var mensaje = `
              <h1>NOTIFICACIÓN - CORREO DE NUEVOS SERVIDORES PÚBLICOS</h1>
              Estimado(a): ${datos_usuario.nombres} ${
                  datos_usuario.ap_paterno
                } ${datos_usuario.ap_materno} <br>
              El motivo de la presente es para informarle que se registro un nuevo servidor público con los siguientes datos:<br>Nombre :${this.form.nombres.toUpperCase()}  ${this.form.ap_paterno.toUpperCase()} ${this.form.ap_materno.toUpperCase()}
              
              <br> ${correo_funcionario[1]}  <br> 
              Saludos cordiales.`;
                //envio de correos a jefe uti
                await this.$service.sendEmail({
                  correo: datos_usuario.correo,
                  asunto: `NOTIFICACIÓN - CORREO DE NUEVOS SERVIDORES PÚBLICOS`,
                  mensaje: mensaje.replace(/<[^>]+>/g, ""),
                  html: mensaje
                });
                //envio de correos a otra persona
                var mensaje_extra = `
              <h1>NOTIFICACIÓN - CORREO DE NUEVOS SERVIDORES PÚBLICOS</h1>
              Estimado(a): JAVIER COSTAS ALIAGA <br>
              El motivo de la presente es para informarle que se registro un nuevo servidor público con los siguientes datos:<br>Nombre :${this.form.nombres.toUpperCase()}  ${this.form.ap_paterno.toUpperCase()} ${this.form.ap_materno.toUpperCase()}
              
              <br> ${correo_funcionario[1]}  <br> 
              Saludos cordiales.`;

                datos_usuario.correo_extra =
                  "javier.costas@economiayfinanzas.gob.bo";
                await this.$service.sendEmail({
                  correo: datos_usuario.correo_extra,
                  asunto: `NOTIFICACIÓN - CORREO DE NUEVOS SERVIDORES PÚBLICOS`,
                  mensaje: mensaje_extra.replace(/<[^>]+>/g, ""),
                  html: mensaje_extra
                });
              } else {
                this.$message.info(
                  "No se notifico por correo ya que el servidor no posee un correo registrado"
                );
              }

              this.loading = false;
              this.close();
            } catch (error) {
              console.log(error);
            }
            this.loading = false;
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.mayuscula input {
  text-transform: uppercase;
}
.file-empty {
  p {
    font-size: 2em;
  }
  background-color: #b2dcff6e;
  border-radius: 40px;
  border: 2px dashed #004eb4;
  color: #649de9;
  cursor: pointer;
  font-weight: bold;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
  .input-file {
    cursor: pointer;
    font-size: 10000px;
    margin: 0;
    opacity: 0;
    outline: 0 none;
    padding: 0;
    position: absolute;
    right: -1000px;
    top: -1000px;
  }
}
.file-upload {
  p {
    font-size: 2em;
  }
  background-color: #b2ffd56e;
  border-radius: 40px;
  border: 2px dashed #00b469;
  color: #649de9;
  cursor: pointer;
  font-weight: bold;
  overflow: hidden;
  padding: 0.5em;
  position: relative;
  text-align: center;
  width: 100%;
  height: 100%;
  .input-file {
    cursor: pointer;
    font-size: 10000px;
    margin: 0;
    opacity: 0;
    outline: 0 none;
    padding: 0;
    position: absolute;
    right: -1000px;
    top: -1000px;
  }
}
.file-block {
  color: #f7fff7;
  background-color: #15be86;
  transition: all 1s;
  position: relative;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-radius: 25px;
  cursor: pointer;
  .v-icon {
    color: white;
  }
  span {
    padding: 0 3px;
  }
}
.file-info {
  display: flex;
  align-items: center;
  font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/persona/dialogs/CrearActualizarPersona.vue